export const AUTH_LOGIN = "auth/login";
export const AUTH_LOGOUT = "auth/logout";
export const AUTH_SIGN_UP = "auth/signup";
export const AUTH_ADMIN_LOGIN = "auth/admin_login";
